import {useEffect, useState} from "react";
import InfiniteScroll from 'react-infinite-scroll-component';
import {deleteClient, getParkedList} from "../../API";
import Loader from "../../Components/Loader";
import ErrorDialog from "../../Components/ErrorDialog";
import Header from "../../Components/Header";
import {Link} from "react-router-dom";
import {DISPLAY_DATE_FORMAT, DISPLAY_TIME_FORMAT, PATH_PARKED_DETAIL, PAYMENT_TYPES} from "../../constants";
import withUserAuth from "../../Behavior/withUserAuth";
import withSideMenu from "../../Behavior/withSideMenu";
import Spinner from "../../Components/Spinner";
import TextSearch from "../../Components/TextSearch";
import {useDebouncedEffect} from "../../Hooks/useDebouncedEffect";
import moment from 'moment';


const PAGE_SIZE = 50;

const ParkedList = ({onSidePanelOpen}) => {
    const [pageNo, setPageNo] = useState(1);
    const [parkedItems, setParkedItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState({});
    const [showSearch, setShowSearch] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [hasMore, setHasMore] = useState(true);

    const sendAPIRequest = async (page = pageNo, searchstring = searchText) => {
        const params = {page, pagesize: PAGE_SIZE, searchstring};
        const {code, data, error} = await getParkedList(params);
        if (code === 200) {
            setHasMore(data.isNextPageExist);
            if (page === 1) {
                setParkedItems(data.saleList);
            } else {
                setParkedItems([...parkedItems, ...data.saleList])
            }
            setPageNo((page + 1));
        } else {
            setError({message: error, retry: true});
        }
        setLoading(false);
    }

    useEffect(() => {
        sendAPIRequest(1, searchText);
    }, []);

    useEffect(() => {
        const root = document.getElementById('sidebar-content');
        if (!loading && hasMore && root.scrollHeight <= root.clientHeight) {
            sendAPIRequest();
        }
    }, [loading, hasMore]);

    const handleRetry = async () => {
        setError({});
        setLoading(true)
        await sendAPIRequest(1);
    }

    const handleDelete = async ({accountid, name}) => {
        const isConfirm = await window.confirm(`Are you sure you want to delete ${name}?`);
        if (isConfirm) {
            setLoading(true);
            const {code, error} = await deleteClient({accountid})
            if (code === 200) {
                await sendAPIRequest();
            } else {
                setLoading(false);
                setError({message: error, retry: false});
            }
        }
    }

    const onSearchClick = () => {
        setShowSearch(true);
    }

    const onSearchClose = () => {
        setShowSearch(false);
        setSearchText('');
        setLoading(true);
        sendAPIRequest(1, '');
    }

    useDebouncedEffect(async () => {
        if (showSearch) {
            setLoading(true);
            await sendAPIRequest(1);
        }
    }, [searchText], 500)

    const onRetry = !!error.retry ? handleRetry : null;

    return (
        <>
            {loading && <Loader/>}
            {!!error.message &&
                <ErrorDialog isOpen={true} content={error.message} onClose={() => setError({})} onRetry={onRetry}/>}
            <Header title={"Parked List"} onSidePanelClick={onSidePanelOpen} onSearchClick={onSearchClick}/>
            <TextSearch isVisible={showSearch} onClose={onSearchClose} onTextChange={setSearchText}
                        searchText={searchText}/>
            <div id='appCapsule'>
                {/* Items */}
                {/* details */}
                <div className="section">
                    <InfiniteScroll
                        className="listview receipts-filter filter-items image-listview no-line no-arrow inset"
                        dataLength={parkedItems.length}
                        next={sendAPIRequest}
                        hasMore={hasMore}
                        loader={<Spinner/>}
                        scrollableTarget={"sidebar-content"}
                    >
                        {
                            parkedItems.map(sale => {
                                let paymentType = sale?.salePayments?.[0]?.paymentTypeId || 0;
                                return (
                                    <li key={sale.invoiceId} className="items-card card card-border" data-item="today">
                                        <Link to={PATH_PARKED_DETAIL} state={{sale}} className="item">
                                            <div className="in">
                                                <div>
                                                    <h4>{moment(sale.invoiceDate).format(DISPLAY_DATE_FORMAT)}</h4>
                                                    <p>{moment(sale.invoiceDate).format(DISPLAY_TIME_FORMAT)}</p>
                                                </div>
                                                <div>
                                                    <h4>{sale.grandTotal}</h4>
                                                    <p>{PAYMENT_TYPES[paymentType]}</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                )
                            })
                        }
                        {
                            parkedItems.length === 0 &&
                            <span className={"fontsize-heading"}
                                  style={{textAlign: 'center'}}>No Parked Item Found</span>
                        }
                    </InfiniteScroll>
                </div>
            </div>
        </>
    )
}

export default withUserAuth(withSideMenu(ParkedList));
